import { atom, useRecoilState } from "recoil";

const reportsFiltersetSelectionStateAtom = atom<FiltersetSelectionType>({
    key: "reportsFiltersetSelection",
    default: "reported",
});

const useReportsFiltersetSelectionState = () => {
    const [state, setState] = useRecoilState(reportsFiltersetSelectionStateAtom);

    return {
        state,
        setState,
    };
};

export default useReportsFiltersetSelectionState;
